export function MobileNotice() {
  return (
    <main className="mobile-notice">
      <p className="eyebrow">WAVELET AUDIO · BRAND STUDIO</p>
      <h1>THE SIGNAL NEEDS<br />A WIDER STAGE.</h1>
      <p>
        Open this studio on a desktop browser at 900px or wider to compose and export full-resolution
        campaign assets.
      </p>
    </main>
  );
}
